import React from 'react';
import AdminApi from '../../../apis/adminApis';

interface DownloadReportProps {
  reportType: string;
  timeRange: string;
}

export const downloadReport = async ({ reportType, timeRange }: DownloadReportProps) => {
  try {
    const response = await AdminApi.exportReport(reportType, timeRange);
    
    // Create blob from the response
    const blob = new Blob([response.data], { type: 'text/csv' });
    
    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);
    
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = url;
    
    // Set the file name
    const date = new Date().toISOString().split('T')[0];
    link.setAttribute('download', `${reportType}-report-${date}.csv`);
    
    // Append to the document
    document.body.appendChild(link);
    
    // Trigger the download
    link.click();
    
    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
    
    return true;
  } catch (error) {
    console.error('Error downloading report:', error);
    return false;
  }
};

// Usage in the Reports component:
/*
  const handleDownloadReport = () => {
    const success = await downloadReport({
      reportType: reportType,
      timeRange: timeRange
    });
    
    if (success) {
      // Show success message
    } else {
      // Show error message
    }
  };
*/